<h2 mat-dialog-title>{{ data.commentType }}</h2>
<mat-dialog-content>
  <div class="comment-text">{{ data.text }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>